import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

function Blogs() {
    const [blogs, setBlogs] = useState([]);

    useEffect(() => {
        axios
            .get(process.env.REACT_APP_API_URL+"/blogs")
            .then((res) => setBlogs(res.data))
            .catch((err) => console.error("Error fetching blogs:", err));
    }, []);

    return (
        <div style={{ padding: "20px" }}>
            <h1>All Blogs</h1>
            {blogs.length === 0 && <p>No blogs found.</p>}
            <ul>
                {blogs.map((blog) => (
                    <li key={blog.id} style={{ marginBottom: "10px" }}>
                        <Link to={`/blogs/${blog.id}`}>
                            <strong>{blog.title}</strong>
                        </Link>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default Blogs;